import { render, staticRenderFns } from "./ModificarDescuentos.vue?vue&type=template&id=4b634eda&scoped=true&"
import script from "./ModificarDescuentos.vue?vue&type=script&lang=js&"
export * from "./ModificarDescuentos.vue?vue&type=script&lang=js&"
import style0 from "./ModificarDescuentos.vue?vue&type=style&index=0&id=4b634eda&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b634eda",
  null
  
)

export default component.exports